
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.276 6.527H8.25c-.95 0-1.724.774-1.724 1.724v3.274L4.966 12.64a.469.469 0 000 .762l1.58 1.129c.123.83.84 1.47 1.705 1.47h6.025c.95 0 1.724-.774 1.724-1.725V8.251c0-.95-.774-1.724-1.724-1.724zm-2.026 6.587c-.11 0-.196-.035-.22-.13l-.192-.668h-1.15l-.19.667c-.026.096-.11.131-.221.131-.176 0-.412-.11-.412-.271 0-.01.005-.03.01-.05l.969-3.158c.045-.151.23-.222.417-.222.19 0 .376.07.421.222l.97 3.158c.005.02.01.035.01.05 0 .155-.236.271-.412.271z","fill":"#6C6C6C"}}),_c('path',{attrs:{"d":"M10.824 11.803h.874l-.437-1.541-.437 1.541zM5.59 8.251c0-.63.22-1.208.586-1.664a2.515 2.515 0 01-1.44-.452c-.409.285-.905.452-1.44.452a.264.264 0 010-.529 1.99 1.99 0 001.026-.283A2.521 2.521 0 013.66 4.32h-.365a.264.264 0 110-.529h1.176v-.641a.264.264 0 11.529 0v.641h1.176a.264.264 0 010 .529h-.365a2.521 2.521 0 01-.66 1.454c.3.18.65.283 1.025.283.14 0 .253.108.263.245a2.651 2.651 0 011.811-.713h1.222V4.476l1.56-1.115a.469.469 0 000-.763L9.455 1.469A1.727 1.727 0 007.75 0H1.724C.774 0 0 .773 0 1.724v6.025c0 .95.773 1.724 1.724 1.724H5.59V8.25z","fill":"#6C6C6C"}}),_c('path',{attrs:{"d":"M4.736 5.444c.29-.3.486-.69.544-1.123H4.193c.058.434.254.823.543 1.123z","fill":"#6C6C6C"}})])
          )
        }
      }
    